import React from "react";
import styled from "styled-components";
import { motion } from "framer-motion";
import { secondaryBtn, FlexContainer, InviteContainer } from "../styles";
import loginbg from "../img/login-bg.png";
import InviteText from "../components/InviteText";

const Login = () => {
  const promoText = [
    "New mortgage rates to brag about",
    "Build you wealth faster.",
    "Get a 5 year fixed rate of 1.74% / 1.76% APR*.",
  ];

  return (
    <MainLogin bg={loginbg}>
      <FlexContainer>
        <InviteText header1={promoText[0]} para={promoText[2]} />

        <FormContainer>
          <MainForm>
            <div className="form-text">
              <h3> Welcome Back</h3>
              <p> One login for all Mazuma products</p>
            </div>

            <div className="form-container">
              <form action="">
                <div className="email-div">
                  <label htmlFor="email"> Email address</label>
                  <input type="email" name="email" id="email" />
                </div>

                <div className="password-div">
                  <label htmlFor="password"> Password</label>
                  <input type="password" name="password" id="password" />
                </div>

                <div className="checkbox">
                  <input id="ch1" type="checkbox" className="Checkbox-input" />
                  <label htmlFor="ch1" className="Checkbox-label">
                    Remember me
                  </label>
                </div>

                <div className="submit-btn">
                  <GetStarted type="submit"> Login </GetStarted>
                </div>
              </form>
            </div>
          </MainForm>
        </FormContainer>
      </FlexContainer>
    </MainLogin>
  );
};

const MainLogin = styled(InviteContainer)``;

const GetStarted = styled(secondaryBtn)`
  background: #19456b;
  border: none;
`;

const FormContainer = styled(motion.div)`
  color: black;
  display: flex;
  justify-content: flex-end;
  margin: 3rem 0rem;

  div {
    padding: 1rem 0rem;
  }
`;

const MainForm = styled(motion.div)`
  h2,
  h3,
  p {
    white-space: normal;
    font-family: "Roboto", "Arial";
  }
  background: #f8f1f1;
  min-height: 20rem;
  width: 28rem;
  border-top-left-radius: 0.3rem;
  border-bottom-left-radius: 0.3rem;
  box-shadow: 1px 2px 4px rgba(0, 0, 0, 0.4);

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .form-text,
  .submit-btn {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;

    h3 {
      font-size: 1.9rem;

      @media (max-width: 370px) {
        font-size: 1.5rem;
      }
    }

    p {
      padding: 0.5rem 0rem;
      font-size: 0.9rem;

      @media (max-width: 370px) {
        font-size: 0.8rem;
      }
    }
  }

  .checkbox {
    font-size: 18px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;

    label {
      font-size: 0.8rem;
      font-weight: 600;
      padding-left: 0.3rem;
    }

    input {
      margin: 0;
      appearance: none;
      display: block;
      width: 18px;
      height: 18px;
      background-color: #fff;
      border: 2px solid #dadada;
      border-radius: 4px;
      outline: none;

      &:checked {
        position: relative;
        background-color: #5290ff;
        border-color: transparent;

        /* The checkmark */
        &::after {
          box-sizing: border-box;
          content: "";
          position: absolute;
          width: 6px;
          height: 10px;
          border: 2px solid #fff;
          border-top: none;
          border-left: none;
          transform-origin: bottom right;
          transform: translateX(0) translateY(1px) rotate(45deg);
        }
      }
    }
  }

  .password-div,
  .email-div,
  .submit-btn {
    display: flex;
    flex-direction: column;
    justify-content: center;

    label {
      font-size: 0.8rem;
      font-weight: bold;
    }

    input {
      border: none;
      font-size: 1rem;
      padding: 0.3rem 1rem;
      border-radius: 0.3rem;
      box-shadow: inset 0px 4px 4px rgba(0, 0, 0, 0.25);
    }
  }
`;

export default Login;
